<template>
	<!-- bg-overlay bg_image -->
	<Layout :header-transparency="false" :show-top-header="true">
		<!-- <div class="slider-area slider-style-4 variation-2 slider-dot rn-slick-dot rn-slick-arrow">
			<VueSlickCarousel v-bind="sliderSetting">
				<div v-for="(slider, index) in sliderData" :key="index" class="single-slide">
					<div class="height-650 bg-overlay"
						:style="{'background-image': `url(${require(`@/assets/images/edge/home/${slider.image}`)})`}">
						<div class="container">
							<div class="row row--30 align-items-center">
								<div class="col-lg-12">
									<div class="inner text-center">
										<h1 class="title" v-html="slider.title" />
										<p class="description" v-html="slider.description" />										
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</VueSlickCarousel>
		</div> -->
		
		<!-- <Separator />
		
		<div class="slider-perosonal-portfolio height-650 bg_image"
		     data-black-overlay="1"
		     :style="{'background-image': `url(${require(`@/assets/images/edge/home/slide-8.png`)})`}">
		</div>
		
		<Separator />
		
		<div class="slider-perosonal-portfolio height-650 bg_image"
		     data-black-overlay="1"
		     :style="{'background-image': `url(${require(`@/assets/images/edge/home/slide-11.jpg`)})`}">
		</div>
		
		<Separator />
		
		<div class="slider-perosonal-portfolio height-650 bg_image"
		     data-black-overlay="1"
		     :style="{'background-image': `url(${require(`@/assets/images/edge/home/slide-12.jpg`)})`}">
		</div>
		
		<Separator />
		
		<div class="slider-perosonal-portfolio height-650 bg_image"
		     data-black-overlay="1"
		     :style="{'background-image': `url(${require(`@/assets/images/edge/home/slide-13.jpg`)})`}">
		</div>
		
		<Separator />		
		
		<div class="slider-perosonal-portfolio height-650 bg_image"
		     data-black-overlay="1"
		     :style="{'background-image': `url(${require(`@/assets/images/edge/home/slide-14.png`)})`}">
		</div>
		
		<Separator /> -->
		
		<!-- <div class="slider-perosonal-portfolio height-650 bg_image" style="width: 100%;"
		     data-black-overlay="1"
		     :style="{'background-image': `url(${require(`@/assets/images/edge/home/slide-15.png`)})`}">
		</div> -->
		
		<div class="homeimg">
			<img id="homePic">
		</div>
		
		<Separator />		
		
		<!-- Start About Area -->
		<!-- <AboutFive/> -->
		<!-- End About Area -->		

		<!-- Start About Area -->
		<AboutFour/>
		<!-- End About Area -->		
		
		<Separator />

		<div class="rwt-portfolio-area rn-section-gap">
			<div class="container">
				<div class="row">
					<Breadcrumb :bread-style="2" :bread-data="breadData" title=" 产 品 自 研 " current-url="" />

					<div class="rn-blog-area rn-section-gap ptb--60">
						<div class="container">
							<div class="row mt_dec--30">
								<div class="col-lg-12">
									<div class="row row--15">
										<div class="col-lg-4 col-md-6 col-12 mt--30" data-aos="slide-up"
											data-aos-duration="800" :data-aos-delay="100 + index"
											v-for="(blog, index) in HomeProducts" :key="index">
											<BlogPost :blog="blog" />
										</div>
									</div>
								</div>
								<div class="col-lg-12 text-center">
									<div class="rwt-load-more text-center mt--60">
										<a class="btn-default" href="/products/1">
											查 看 更 多
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<Separator />

		<div class="rwt-portfolio-area rn-section-gap">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<SectionTitle text-align="center" subtitle="Introduction" title="关 于 我 们" data-aos="fade-up" />
					</div>
					<Tab :tab-data="tabData" :tab-style="4" />
				</div>
			</div>
		</div>

	</Layout>
</template>

<script>
	import Layout from "../components/common/Layout";
	import Separator from "../components/elements/separator/Separator";
	import SectionTitle from "../components/elements/sectionTitle/SectionTitle";
	import BlogPost from "../components/blog/BlogPost";
	import BlogPostMixin from "../mixins/BlogPostMixin";
	import VueSlickCarousel from "vue-slick-carousel";
	import Portfolio from "../components/elements/portfolio/Portfolio";
	import Progressbar from "../components/elements/progressbar/Progressbar";
	import Timeline from "../components/elements/timeline/Timeline";
	import ServiceFour from "../components/elements/service/ServiceFour";
	import Tab from '../components/elements/tab/Tab'
	import Breadcrumb from '../components/elements/breadcrumb/Breadcrumb'
	import AboutFive from '../components/elements/about/AboutFive'
	import AboutFour from '../components/elements/about/AboutFour'

	export default {
		name: 'EdgeHome',
		components: {
			ServiceFour,
			Timeline,
			Progressbar,
			Portfolio,
			BlogPost,
			SectionTitle,
			Separator,
			Layout,
			VueSlickCarousel,
			Tab,
			Breadcrumb,
			AboutFive,
			AboutFour
		},
		mixins: [BlogPostMixin],
		data() {
			return {
				sliderSetting: {
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					arrows: true,
					responsive: [{
							breakpoint: 800,
							settings: {
								slidesToShow: 1,
							}
						},
						{
							breakpoint: 993,
							settings: {
								slidesToShow: 1,
							}
						},
						{
							breakpoint: 580,
							settings: {
								slidesToShow: 1,
							}
						},
						{
							breakpoint: 481,
							settings: {
								slidesToShow: 1,
							}
						}
					]
				},
				sliderData: [
					{
						image: 'slide-7.jpg',
						title:'科技 让制造更简单',
						description:'MORE INNOVATIVE CONVERIENT EFFECTIVE FOR MANUFACTURING'
						// title: `网络化分布式运动控制系统 <br/> 适用于数控机床、起重机械、包装机械、工业机器人等`,
						// description: `涵盖PLC/PAC/高度IO/运动控制软件/伺服器/变频器/伺服电机`
					}, 
					{
						image: 'slide-8.png',
						title:'',
						description:''
					},
					{
						image: 'slide-9.jpg',
						title:'',
						description:''
					},
					{
						image: 'slide-10.jpg',
						title:'',
						description:''
					},
					{
						image: 'slide-11.jpg',
						title:'',
						description:''
					}					
				],
				/* 关于我们 - 业务分布Tab的数据 */
				tabData: [
					{
						id: 'edge-applications-menu',
						text: '研发方向',
						menuTitle: '',
						menuContext: ``,
						dataList: [
							{
								image: 'IntelligenceIndustrialSolutions.jpg',
								title: '工业解决方案',
								description: '爱智控制工业解决方案已得到广泛应用，构建了从数十点到数万点的各类控制系统，为用户解决了设备监控、车间管理、工艺改进、产线升级、系统集成等问题， 实现了物料、设备和人力等企业资源的统一配置。系列产品提供成套自动化解决方案，为企业提高了设备运行效率和管理运营效率，降低了整体制造成本，同时满足了用户低成本、多功能的需求。',
								toUrl:'/project-show/2'
							},
							{
								image: 'CollaborativeAutomation.jpg',
								title: '协同自动化',
								description: '爱智控制协同自动化系统以现场总线、控制总线和车间级管理网络的集成为基础，实现从现场级到控制级、再到工厂管理级的协同自动化。<br/>内容涵盖过程控制、运动控制、软仪表测量、工程组态、人机界面、监控管理和工业通信网络。是支持用户定制其现场控制系统、批量控制系统、制造执行系统和全生命周期管理系统的统一集成架构。',
								toUrl:'/project-show/1'
							},
							{
								image: 'ifactory.jpg',
								title: '智能工厂',
								description: '智能工厂以实现生产过程和经营业务最优化为目的。基于定制化工厂解决方案与协同自动化系统，对物料、设备、工序、能源、人力等信息进行统一监控和协同管理。<br/>为企业的运行绩效进行精确度量，充分考虑成本、质量、管理、安全、配置和扩展等问题，实现产品全生命周期管理，以提升制造工厂的智能程度和工程开发效率，降低运行维护成本，方便扩展升级。',
								toUrl:'/project-show/1'
							}
						],
					},
					{
						id: 'edge-awards-menu',
						text: '资质奖项',
						menuTitle: '爱智控制参与制定了国际标准 5 项，国家标准 6 项',
						menuContext: '其中国际标准 “Real Time Ethernet EPA (Ethernet for Plant Automation)” 与 Profinet、Ethernet/IP 等国际知名标准一起被纳入IEC61158。“用于工业测量与控制系统的 EPA 系统结构与通信标准”（GB/T 20171-2006）获得了国家标准创新贡献一等奖。',
						dataList: [{
								image: 'NationalTechnicalInventionAward.jpg',
								title: '国家级产品研发',
								description: '',
								toUrl:'/about-us'
							},
							{
								image: 'shengjimix.jpg',
								title: '省级技术中心',
								description: '',
								toUrl:'/about-us'
							}
						],
					},
					{
						id: 'edge-about-us',
						text: '实施案例',
						menuTitle: '',
						menuContext: '',
						dataList: [{
								image: 'home_prj_hlhkzxt.jpg',
								title: '回流焊、波峰焊控制系统',
								description: '',
								toUrl:'/project-show/5'
							},
							{
								image: 'home_prj_bljqr.jpg',
								title: '并联高速机器人',
								description: '',
								toUrl:'/project-show/10'
							},
							{
								image: 'home_prj_qygl.jpg',
								title: '企业管理系统',
								description: '',
								toUrl:'/project-show/15'
							}
						]
					}
				],
				breadData: {
					Level1Url: '掌握核心科技 , 让装备制造具有中国“心”',
				},
				/* 产品自研 - 首页产品相关数据 */
				HomeProducts: [
					{
							id: '10',
							img: require(`@/assets/images/edge/products/HomeMAC1680.jpg`),
							author: 'MAC系列运动控制器',
							authorId: '1',
							view: '70 views',
							publishedAt: 'MAC1680',
							title: '集可编程控制，运动控制，网关、数控、机器人控制五大功能于一体的分布式PLC',
							excerpt: 'We have always known the power of digital we\'ve.',
							body: ``,
							categories: ['Development', 'Company', 'Marketing'],
							tags: ['Corporate', 'Agency', 'Creative', 'Design']
					},				
					{
							id: '3',
							img: require(`@/assets/images/edge/products/HomeMAC1100.jpg`),
							author: 'MAC系列中型控制器',
							authorId: '2',
							view: '70 views',
							publishedAt: 'MAC1100',
							title: '高性价比，具备远程IO操作功能的中型PLC。通信接口丰富， 设计独特，适用于集散控制系统',
							excerpt: 'We have always known the power of digital we\'ve.',
							body: ``,
							categories: ['UX Design', 'Company'],
							tags: ['Minimal', 'Company', 'Development', 'Design']
					},
					{
							id: '13',
							img: require(`@/assets/images/edge/products/HomePEC8000.jpg`),
							author: '分布式以太网控制器',
							authorId: '3',
							view: '70 views',
							publishedAt: 'PEC8000',
							title: '国内最早研发、生产、推广适合分布式控制场合的PLC，开创了分布式控制的新局面',
							excerpt: 'We have always known the power of digital we\'ve.',
							body: ``,
							categories: ['Development', 'UX Design', 'Business', 'Company'],
							tags: ['App Landing', 'Startup', 'Development', 'Design']
					},
					{
							id: '2',
							img: require(`@/assets/images/edge/products/HomePAG313.jpg`),
							author: '边缘网关',
							authorId: '2',
							view: '70 views',
							publishedAt: 'PAG313',
							title: '支持EPA，Modbus TCP/UDP，Profibus-DP扩展等多种通信协议',
							excerpt: 'We have always known the power of digital we\'ve.',
							body: ``,
							categories: ['Marketing', 'UX Design', 'Business'],
							tags: ['App', 'Business', 'Software', 'Design']
					},
					{
							id: '31',
							img: require(`@/assets/images/edge/products/HomeEIO163.jpg`),
							author: '扩展IO模块',
							authorId: '5',
							view: '70 views',
							publishedAt: 'EIO163',
							title: '具备数字量输入、输出，模拟量输入、输出、混合等多种配套扩展模块',
							excerpt: 'We have always known the power of digital we\'ve.',
							body: ``,
							categories: ['App Development', 'UX Design', 'Application', 'Art'],
							tags: ['Company', 'Corporate', 'Development', 'Design']
					},
					{
							id: '51',
							img: require(`@/assets/images/edge/products/HomeCUSSerial.jpg`),
							author: '环网伺服器',
							authorId: '40',
							view: '70 views',
							publishedAt: 'CUS系列',
							title: '爱智控制自主研发的小功率交流伺服驱动器，支持多种控制模式，满足多种运动控制需求',
							excerpt: 'We have always known the power of digital we\'ve.',
							body: ``,
							categories: ['Application', 'UX Design', 'Art'],
							tags: ['App', 'Landing', 'Design', 'Software']
					},
					{
							id: '19',
							img: require(`@/assets/images/edge/products/HomeEDC5000.jpg`),
							author: '可编程嵌入式开发平台',
							authorId: '51',
							view: '70 views',
							publishedAt: 'EDC5000',
							title: '具有多级主从设备扩展和第三方设备互联能力，以网络系统为整体，对系统中的设备进行统一管理和编程开发',
							excerpt: 'We have always known the power of digital we\'ve.',
							body: ``,
							categories: ['UX Design', 'Company'],
							tags: ['Minimal', 'Company', 'Development', 'Design']
					},
					{
							id: '53',
							img: require(`@/assets/images/edge/products/HomePLCConfigLogo.png`),
							author: '软件产品',
							authorId: '2',
							view: '70 views',
							publishedAt: 'PLC_Config 2.11.10',
							title: '公司专为各系列可编程控制器进行逻辑编程而自主开发的T型图，功能块组态软件',
							excerpt: 'We have always known the power of digital we\'ve.',
							body: ``,
							categories: ['UX Design', 'Company'],
							tags: ['Minimal', 'Company', 'Development', 'Design']
					},
					{
							id: '54',
							img: require(`@/assets/images/edge/products/HomeDviewLogo.png`),
							author: '软件产品',
							authorId: '3',
							view: '70 views',
							publishedAt: 'Dview HMI',
							title: '公司专为设备管理、实时数据管理、视频管理、数据库管理等功能自主研发的监控管理系统开发平台',
							excerpt: 'We have always known the power of digital we\'ve.',
							body: ``,
							categories: ['Development', 'UX Design', 'Business', 'Company'],
							tags: ['App Landing', 'Startup', 'Development', 'Design']
					}
				]
			}
		},/* end data(){} */		
	}
</script>

<style lang="scss">
	.homeimg{		
		@media only screen and (max-width: 767px){
			display: flex;
		}
		
		@media only screen and (min-width: 768px) and (max-width: 991px){
			height: 350px;
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center;
		}
		
		@media only screen and (min-width: 992px) and (max-width: 1199px){
			height: 650px;
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center;
		}
	}
	#homePic{
		width: 100%;	
		height: 100%;
		max-width: 100%;
		max-height: 100%; 
		content:url(../assets/images/edge/home/slide-15.png);
		
		@media only screen and (max-width: 767px){
			content:url(../assets/images/edge/home/slide-15_small.png);
		}
		@media only screen and (min-width: 768px) and (max-width: 991px){
			content:url(../assets/images/edge/home/slide-15_medium.png);
		}
	}
	
	// @media only screen and (max-width: 767px){
	// 	height: 100%;
	// 	content:url(../assets/images/edge/home/slide-15_small.png);
	// }
	
	// @media only screen and (min-width: 768px) and (max-width: 991px){	
	// 	height: auto;
	// 	content:url(../assets/images/edge/home/slide-15_medium.png);
	// }
	
	// @media only screen and (min-width: 992px) and (max-width: 1199px){
	// 	height: auto;
	// 	content:url(../assets/images/edge/home/slide-15.png);
	// }
</style>